export default __webpack_public_path__ + "static/media/cards-organic@2x.a0f44d5d.png";